export const CONGESTION_THRESHOLD_LOW = 0.9;
export const CONGESTION_THRESHOLD_LIGHT = 0.7;
export const CONGESTION_THRESHOLD_MEDIUM = 0.5;
export const CONGESTION_THRESHOLD_HEAVY = 0.4;

export const CONGESTION_ZOOM_LEVEL_THRESHOLD = 15;
export const CONGESTION_REFRESH_INTERVAL = 30000;
export const CONGESTION_SHAPE_WEIGHT_DEFAULT = 4;
export const CONGESTION_SHAPE_WEIGHT_BOLD = 6;
export const INCIDENTS_REFRESH_INTERVAL = 30000;
export const INCIDENTS_SHAPE_WEIGHT = 7;

export const DISRUPTIONS_REFRESH_INTERVAL = 30000;
export const DISRUPTIONS_MARKER_CLUSTER_FOCUS_ZOOM = 19;

export const INCIDENTS_MARKER_CLUSTER_FOCUS_ZOOM = 19;
export const ROUTE_ALERTS_REFRESH_INTERVAL = 30000;

export const CONGESTION_THRESHOLD_GREEN = 0.9;
export const CONGESTION_THRESHOLD_YELLOW = 0.7;
export const CONGESTION_THRESHOLD_ORANGE = 0.5;
export const CONGESTION_THRESHOLD_RED = 0.4;
export const CONGESTION_THRESHOLD_MAROON = 0.3;

export const CONGESTION_COLORS = {
    MAROON: 'Maroon',
    RED: 'Red',
    ORANGE: 'Orange',
    YELLOW: 'Yellow',
    GREEN: 'Green',
};
